import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/AmusementTestimonial`;

function paramsToStringList(params) {
  let stringparams = "?";
  Object.entries(params).map(([key, value]) => {
      if (value != undefined && value != null)
          stringparams = stringparams + key + "=" + value + "&";
  })
  stringparams = stringparams.substr(0, stringparams.length - 1);
  return stringparams;
}

const ApiAmusementTestimonial = {
  getAmusementTestimonials: (params) => {
    const url = `${baseServiceUrl}/getAllAmusementTestimonials`+ paramsToStringList(params);
    return ServiceApi.get(url, { params });
  },
  getAmusementTestimonialById: (params) => {
    const url = `${baseServiceUrl}/getAmusementTestimonialById?id=` + params;
    return ServiceApi.get(url, params);
  },
  updateAmusementTestimonial: (params) => {
    const url = `${baseServiceUrl}/updateAmusementTestimonial?id=` + params.id;
    return ServiceApi.put(url, params);
  },
  updateAmusementTestimonialStatus: (params) => {
    const url = `${baseServiceUrl}/updateAmusementTestimonialStatus`;
    return ServiceApi.put(url, params);
  },
  deleteAmusementTestimonial: (params) => {
    const url = `${baseServiceUrl}/deleteAmusementTestimonial`+ paramsToStringList(params);
    return ServiceApi.delete(url, params);
  },
  createAmusementTestimonial: (params) => {
    const url = `${baseServiceUrl}/createAmusementTestimonial`;
    return ServiceApi.post(url, params);
  },
};

export default ApiAmusementTestimonial;